import '../components/style.less';

export const customizeRequiredMark = (
  label: React.ReactNode,
  { required }: { required: boolean },
) => (
  <>
    {label}
    {required && <span className="required-mark">*</span>}
  </>
);
